module.exports = __webpack_public_path__ + "img/texture-brick-1-top-blank.10660854.jpg";